import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeCopySource } from './file-type.copysource';
import { FileShareDataset } from 'app/model/dataset/file-share.dataset';


@Metamodel.model({
    name: 'HdfsSource',
    display: [ stringResources.Hdfs_Source ],
    tags: { datasetModel: Metamodel.modelFor(FileShareDataset) }
})
export class HdfsCopySource extends FileTypeCopySource {
    public static readonly RESOURCE_MANAGER_ENDPOINT: IAttribute;
    public static readonly TEMP_SCRIPT_PATH: IAttribute;
    public static readonly DIST_CP_OPTIONS: IAttribute;

    @Metamodel.attribute({})
    public useDistCp: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'RESOURCE_MANAGER_ENDPOINT',
        display: stringResources.SourceActivity_SourceTab_DistCpResourceManagerEndpoint_Label,
        constraint: {
            required: ['useDistCp']
        }
    })
    public resourceManagerEndpoint: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'TEMP_SCRIPT_PATH',
        display: stringResources.SourceActivity_SourceTab_DistCpTempScriptPath_Label,
        constraint: {
            required: ['useDistCp']
        }
    })
    public tempScriptPath: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'DIST_CP_OPTIONS',
        display: stringResources.SourceActivity_SourceTab_DistCpOptions_Label
    })
    public distCpOptions: string;
}
